// extracted by mini-css-extract-plugin
export default {"label":"search-field_label__u3fLP","styledInput":"search-field_styledInput__t+zcl"};